import { api } from "../../api";
import {handleResponse, RequestOptions} from "../types";
import {getCookie, setCookie} from "../../helpers/utils";
import {cookieToken} from "../../constants";

const getList = (data:any) => {
  const authenticity_token = getCookie(cookieToken);
  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };
  return fetch(`${api.admin.reattributedPlayers.list}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
}


const create = (data: any) => {
  const authenticity_token = getCookie(cookieToken);
  const endpoint = api.admin.reattributedPlayers.create;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const verify = (data: any) => {
  const authenticity_token = getCookie(cookieToken);
  const endpoint = api.admin.reattributedPlayers.verify;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      console.log('ERROR: ', error)
      return error
    });
};


export const reattributedPlayersService = {
  getList,
  create,
  verify,
};
